// src/app/core/guards/role.guard.ts
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthserviceService } from '../services/authservice.service';
import { AlertMessage, ServiceService } from '../services/service.service';


export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthserviceService);
  const router = inject(Router);
  const service = inject(ServiceService);

  const expectedRoles: number[] = route.data['roles'];
  const user = authService.usuarioValue;

  if (user && expectedRoles.includes(user.rol!)) {
    return true;
  }

  // Mostrar alerta si no tiene permiso
  const alert: AlertMessage = {
    type: 'error',
    summary: 'Acceso denegado',
    detail: 'No tienes permisos para acceder a esta sección.'
  };
  service.showAlert(alert);

  // Redirigir a una ruta permitida
  return router.parseUrl('/solicitud-listado');
};
